/*
  VAIROK · «Das könnte dir auch gefallen» (sections/vk-lite-recs.liquid).
  Lista final, sin repetir y hasta 4: A) familia (gafas de la familia y sus lentes y clip) → B) recomendaciones de
  Shopify, quitando lentes y accesorios de otra familia (data-acc ≠ data-family de la sección) → C) otras gafas y
  best-sellers. Con menos de 2, la sección se oculta. Si la petición falla, se queda A + C, que ya venía pintado.
*/
(function () {
  'use strict';
  var MAX = 4;
  function items(root, sel) {
    return root ? Array.prototype.slice.call(root.querySelectorAll(sel)) : [];
  }
  function init(sec) {
    if (sec.getAttribute('data-vk-ready')) return;
    sec.setAttribute('data-vk-ready', '1');
    var list = sec.querySelector('[data-vk-recs-list]');
    var url = sec.getAttribute('data-url');
    var fam = sec.getAttribute('data-family') || '';
    var tA = sec.querySelector('template[data-vk-recs-a]');
    var tC = sec.querySelector('template[data-vk-recs-c]');
    if (!list || !url) return;
    fetch(url)
      .then(function (r) { return r.text(); })
      .then(function (text) {
        var doc = new DOMParser().parseFromString(text, 'text/html');
        var recs = items(doc, '[data-vk-recs-items] > li').filter(function (li) {
          var acc = li.getAttribute('data-acc') || '';
          return !acc || acc === fam;
        });
        var all = items(tA && tA.content, 'li').concat(recs, items(tC && tC.content, 'li'));
        var seen = {};
        var out = [];
        all.forEach(function (li) {
          var h = li.getAttribute('data-handle');
          if (!h || seen[h] || out.length >= MAX) return;
          seen[h] = true;
          out.push(document.importNode(li, true));
        });
        if (out.length < 2) {
          sec.hidden = true;
          return;
        }
        list.innerHTML = '';
        out.forEach(function (li) { list.appendChild(li); });
        sec.hidden = false;
      })
      .catch(function () { /* se queda A + C */ });
  }
  function initAll() {
    Array.prototype.forEach.call(document.querySelectorAll('[data-vk-recs]'), init);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initAll);
  else initAll();
  document.addEventListener('shopify:section:load', initAll);
})();
